import { render, staticRenderFns } from "./EducationModal.vue?vue&type=template&id=a1e07e40&scoped=true"
import script from "./EducationModal.vue?vue&type=script&lang=js"
export * from "./EducationModal.vue?vue&type=script&lang=js"
import style0 from "./EducationModal.vue?vue&type=style&index=0&id=a1e07e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e07e40",
  null
  
)

export default component.exports